module.exports = __webpack_public_path__ + "img/Stemness-PRCA_10X_ANS.a1442cb1.png";